/**
 * Auth store — Zustand
 * Persists session to sessionStorage (cleared on tab close).
 * Swap sessionStorage for a token refresh strategy in production.
 */
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user:  null,
      token: null,
      isAuthenticated: false,

      login: (user) =>
        set({
          user,
          token:           user.token,
          isAuthenticated: true,
        }),

      logout: () =>
        set({
          user:            null,
          token:           null,
          isAuthenticated: false,
        }),

      hasRole: (role) => get().user?.role === role,
    }),
    {
      name:    'audit-auth',
      storage: createJSONStorage(() => sessionStorage),
      // Only persist safe fields — never persist raw password
      partialize: (state) => ({
        user:            state.user,
        token:           state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
